<template>
    <div class="relative">
        <Step :step="1" title="Stimme aufnehmen" icon="record" info="<div>Um die Aufnahme zu starten, musst du dem Mikrofonzugriff zustimmen. Nach dem Countdown kannst du deine Botschaft aufnehmen. Aufnahmelänge sind 7 Sekunden.</div>">
            <SoundRecordings></SoundRecordings>
        </Step>

        <Step :step="2" title="Portrait Designen" icon="design" info="Hier hast du die Möglichkeit deine Sprachaufnahme individuell zu gestalten. Bearbeite jeden Unterpunkt um das beste Ergebnis zu erzielen!">
            <WaveConfiguration></WaveConfiguration>
        </Step>
        <Step :step="3" title="Text hinzufügen" icon="text" info="Dem Portrait kannst du nun einen Text hinzufügen. Auch Emojis sind möglich. Den Text kannst du links in der Vorschau frei an die gewünschte Stelle bewegen. Schriftart und Schriftgröße sind frei anpassbar. Bis zu 5 Textzeilen sind möglich.">
            <TextConfiguration></TextConfiguration>
        </Step>
        <Step :step="4" title="Material & Format" icon="material" info="Wähle nun das gewünschte Material aus auf dem dein Stimmportrait gedruckt werden soll.">
            <MaterialFormat></MaterialFormat>
        </Step>
        <Step :step="5" title="QR-Code hinzufügen" icon="extras" info="Hier kannst du deinem Portrait einen QR-Code hinzufügen, um deine Botschaft jederzeit abzuspielen.">
            <Extras></Extras>
        </Step>
    </div>
</template>

<script type="text/javascript">
import Header from "./ControlPanel/Header.vue";
import Step from "./ControlPanel/Step.vue";
import SoundRecordings from './ControlPanel/1_SoundConfiguration/SoundConfiguration.vue';
import WaveConfiguration from "./ControlPanel/2_WaveConfiguration/WaveConfiguration.vue";
import ColorsBackground from "./ControlPanel/3_ColorsBackground/ColorsBackground.vue";
import TextConfiguration from "./ControlPanel/4_TextConfiguration/TextConfiguration.vue";
import Extras from "./ControlPanel/5_Extras/Extras.vue";
import MaterialFormat from "./ControlPanel/6_MaterialFormat/MaterialFormat.vue";

export default {
    components: {
        Header,
        Step,
        SoundRecordings,
        WaveConfiguration,
        ColorsBackground,
        TextConfiguration,
        MaterialFormat,
        Extras
    }
}

</script>
